import { PureComponent } from 'react';
import PropTypes from 'prop-types';

class Recaptcha extends PureComponent {
  static propTypes = {
    elementID: PropTypes.string,
    verifyCallback: PropTypes.func.isRequired,
    sitekey: PropTypes.string.isRequired,
    action: PropTypes.string.isRequired,
    getExecute: PropTypes.func.isRequired,
  };

  static defaultProps = {
    elementID: 'g-recaptcha',
  };

  state = {
    ready: false,
    deferred: false,
  };

  componentDidMount() {
    this.check();
    this.props.getExecute(this.execute);
  }

  check() {
    self.grecaptcha && self.grecaptcha.ready(this.onReady.bind(this));
  }

  onReady() {
    this.setState({ ready: true }, () => {
      if (this.state.deferred) {
        this.execute();
      }
    });
  }

  execute = () => {
    const { sitekey, verifyCallback, action } = this.props;

    if (this.state.ready) {
      self.grecaptcha.execute(sitekey, { action }).then(verifyCallback);
      this.setState({ deferred: false });
    } else {
      this.setState({ deferred: true }, this.check);
    }
  };

  render() {
    return null;
  }
}

export default Recaptcha;
